import React, { useState } from 'react';
import './WordHelp.css';

const WordHelp = ({ prompt }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const getHelpInfo = (prompt) => {
        const lowerPrompt = prompt.toLowerCase();
        
        // Match specific word types first (most specific to least specific)
        if (lowerPrompt.includes('place')) {
            return {
                title: "Place",
                definition: "A location or somewhere you can go",
                examples: ["park", "school", "beach"]
            };
        }
        
        if (lowerPrompt.includes('person')) {
            return {
                title: "Person",
                definition: "A human being or someone you know",
                examples: ["teacher", "friend", "doctor"]
            };
        }
        
        if (lowerPrompt.includes('animal') || lowerPrompt.includes('creature')) {
            return {
                title: "Animal",
                definition: "A living creature that moves around",
                examples: ["dog", "elephant", "bird"]
            };
        }
        
        if (lowerPrompt.includes('thing') || lowerPrompt.includes('object')) {
            return {
                title: "Thing",
                definition: "An object you can touch or see",
                examples: ["ball", "book", "toy"]
            };
        }
        
        if (lowerPrompt.includes('noun')) {
            return {
                title: "Noun",
                definition: "A person, place, thing, or animal",
                examples: ["cat", "house", "teacher"]
            };
        }
        
        if (lowerPrompt.includes('verb') || lowerPrompt.includes('action')) {
            return {
                title: "Verb", 
                definition: "An action word - what someone does",
                examples: ["run", "jump", "dance"]
            };
        }
        
        if (lowerPrompt.includes('adjective')) {
            return {
                title: "Adjective",
                definition: "A word that describes something",
                examples: ["big", "funny", "red"]
            };
        }
        
        if (lowerPrompt.includes('adverb')) {
            return {
                title: "Adverb",
                definition: "A word that describes how something is done",
                examples: ["quickly", "loudly", "carefully"]
            };
        }
        
        if (lowerPrompt.includes('color')) {
            return {
                title: "Color",
                definition: "The color of something",
                examples: ["blue", "green", "purple"]
            };
        }
        
        if (lowerPrompt.includes('number')) {
            return {
                title: "Number",
                definition: "How many of something",
                examples: ["five", "ten", "twenty"]
            };
        }
        
        if (lowerPrompt.includes('moral') || lowerPrompt.includes('lesson')) {
            return {
                title: "Moral or Lesson",
                definition: "Something important you can learn",
                examples: ["friendship is important", "be kind to others", "never give up"]
            };
        }
        
        if (lowerPrompt.includes('name') || (lowerPrompt.includes('person') && !lowerPrompt.includes('a person'))) {
            return {
                title: "Name",
                definition: "What someone is called",
                examples: ["Sarah", "Michael", "Alex"]
            };
        }
        
        if (lowerPrompt.includes('food')) {
            return {
                title: "Food",
                definition: "Something you can eat",
                examples: ["pizza", "cookies", "apples"]
            };
        }
        
        if (lowerPrompt.includes('time of day') || lowerPrompt.includes('time')) {
            return {
                title: "Time of Day",
                definition: "A time when something happens",
                examples: ["morning", "night", "afternoon"]
            };
        }
        
        if (lowerPrompt.includes('day of the week') || lowerPrompt.includes('day')) {
            return {
                title: "Day of the Week",
                definition: "One of the seven days",
                examples: ["Monday", "Saturday", "Friday"]
            };
        }
        
        // Default fallback
        return {
            title: "Word",
            definition: "Think of a word that fits!",
            examples: ["fun", "silly", "awesome"]
        };
    };

    const helpInfo = getHelpInfo(prompt);

    return (
        <div className="word-help">
            <button 
                className="help-button"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                onClick={() => setShowTooltip(!showTooltip)}
                type="button"
            >
                ℹ️
            </button>
            
            {showTooltip && (
                <div className="help-tooltip">
                    <div className="tooltip-header">
                        <strong>{helpInfo.title}</strong>
                    </div>
                    <div className="tooltip-definition">
                        {helpInfo.definition}
                    </div>
                    <div className="tooltip-examples">
                        <strong>Examples:</strong>
                        <div className="examples-list">
                            {helpInfo.examples.map((example, index) => (
                                <span key={index} className="example-word">
                                    {example}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WordHelp;